import type { Brand, BrandAssets } from './type'

export function getLocalBrandAssets(brand: Brand): BrandAssets {
  const logo = {
    dark: `/logo/${brand.logo.dark}`,
    light: `/logo/${brand.logo.light}`
  }
  const logoSm = brand.logo.sm
    ? { dark: `/logo/${brand.logo.sm}`, light: `/logo/${brand.logo.sm}` }
    : logo

  return { favicon: `/fav/${brand.favicon}`, logo, logoSm }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

// Файлы лежат на домене личного кабинета, поэтому относительную ссылку считаем от адреса настроек
function parseAssetUrl(value: unknown, settingsUrl: string): string | null {
  if (typeof value !== 'string' || !value.trim()) return null

  try {
    const url = new URL(value, settingsUrl)

    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null
  } catch {
    return null
  }
}

// Ответ GET /api/public/settings/brand личного кабинета: логотипы и фавиконка у терминала общие с ним,
// компактные логотипы — terminal_logo_*. Файл, который бэкенд не прислал, берётся из localAssets.
export function parseBrandAssets(
  response: unknown,
  settingsUrl: string,
  localAssets: BrandAssets
): BrandAssets {
  if (!isRecord(response)) return localAssets

  return {
    favicon: parseAssetUrl(response.favicon, settingsUrl) ?? localAssets.favicon,
    logo: {
      dark: parseAssetUrl(response.logo_dark, settingsUrl) ?? localAssets.logo.dark,
      light: parseAssetUrl(response.logo_light, settingsUrl) ?? localAssets.logo.light
    },
    logoSm: {
      dark: parseAssetUrl(response.terminal_logo_dark, settingsUrl) ?? localAssets.logoSm.dark,
      light: parseAssetUrl(response.terminal_logo_light, settingsUrl) ?? localAssets.logoSm.light
    }
  }
}
